import _defineProperty from "@babel/runtime/helpers/defineProperty";
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import React from 'react';
import PropTypes from 'prop-types';
import Heading from '../../../../Heading';
import styles from './ModalHeading.st.css';

var ModalHeading = function ModalHeading(_ref) {
  var className = _ref.className,
      headingAppearance = _ref.headingAppearance,
      restProps = _objectWithoutProperties(_ref, ["className", "headingAppearance"]);

  var appearance = headingAppearance === 'custom' ? 'H3' : headingAppearance;
  return /*#__PURE__*/React.createElement(Heading, _extends({}, styles('root', {
    custom: headingAppearance === 'custom'
  }, {
    className: className
  }), restProps, {
    appearance: appearance
  }));
};

ModalHeading.propTypes = _objectSpread(_objectSpread({}, Heading.propTypes), {}, {
  headingAppearance: PropTypes.oneOf(['H2', 'custom'])
});
ModalHeading.defaultProps = {
  headingAppearance: 'custom'
};
export default ModalHeading;